var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoldButtonImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2210_4)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.9375 0H4.8125C4.08789 0 3.49727 0.596094 3.52461 1.31797C3.53008 1.46289 3.53555 1.60781 3.54375 1.75H0.65625C0.292578 1.75 0 2.04258 0 2.40625C0 4.93828 0.916016 6.69922 2.14648 7.89414C3.35781 9.07266 4.83438 9.66602 5.92266 9.9668C6.5625 10.1445 7 10.6777 7 11.2137C7 11.7852 6.53516 12.25 5.96367 12.25H5.25C4.76602 12.25 4.375 12.641 4.375 13.125C4.375 13.609 4.76602 14 5.25 14H10.5C10.984 14 11.375 13.609 11.375 13.125C11.375 12.641 10.984 12.25 10.5 12.25H9.78633C9.21484 12.25 8.75 11.7852 8.75 11.2137C8.75 10.6777 9.18477 10.1418 9.82734 9.9668C10.9184 9.66602 12.3949 9.07266 13.6063 7.89414C14.834 6.69922 15.75 4.93828 15.75 2.40625C15.75 2.04258 15.4574 1.75 15.0938 1.75H12.2062C12.2145 1.60781 12.2199 1.46563 12.2254 1.31797C12.2527 0.596094 11.6621 0 10.9375 0ZM1.33711 3.0625H3.64492C3.89375 5.52617 4.44336 7.17227 5.06406 8.27422C4.3832 7.97344 3.675 7.54961 3.0625 6.95352C2.1875 6.10313 1.47656 4.87539 1.33984 3.0625H1.33711ZM12.6902 6.95352C12.0777 7.54961 11.3695 7.97344 10.6887 8.27422C11.3094 7.17227 11.859 5.52617 12.1078 3.0625H14.4156C14.2762 4.87539 13.5652 6.10313 12.693 6.95352H12.6902Z",
    fill: "#9CA3AF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2210_4"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.75,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoldButtonImage);
export default __webpack_public_path__ + "static/media/gold-button-image.37dc893606d1290e534f92fa8ce0ea65.svg";
export { ForwardRef as ReactComponent };